$(function(){
    if(!$$.isMobile){
        var $items = $("[js-groups-item]").filter('[data-video]');
        if(!$items.length) return;

        var $video_tmp =  '<video loop muted width="100%" height="100%" class="groups-list__item-video" src="VIDEOURL"></video>';

        $items.each(function (i,item) {
            var $item = $(item);
            var $video;

            $item
                .mouseenter(function () {
                   if(!$video){
                       $video = $($video_tmp.replace('VIDEOURL', $item.data('video'))).appendTo($item.find('[js-groups-item-layer]'));
                   }

                    $item.removeClass('groups__item_hover');
                    $video[0].play();
                })
                .mouseleave(function () {
                    if($video){
                        $video[0].pause();
                        $video[0].currentTime = 0;
                    }
                });
        })
    }
});
